export default [
  {
    title: 'หน้าหลัก',
    route: 'home',
    icon: 'HomeIcon',
  },
  
  {
    title: 'ลงทะเบียนคิว',
    route: 'namelist',
    icon: 'CalendarIcon',
  },  {
    title: 'อัพเดทคิว',
    route: 'search',
    icon: 'SearchIcon',
  },
    {
    title: 'รายงาน',
    route: 'reportlist',
    icon: 'FileIcon',
  },
 {
    title: 'ผู้ใช้งาน',
    route: 'userlist',
    icon: 'UserIcon',
    titlesToCheck: 'UserID ผู้ใช้งาน',
  },
 {
    title: 'ตั้งค่า',
    route: 'config',
    icon: 'SettingsIcon',
    titlesToCheck: 'ตั้งค่า',
  },
]
